import { render, staticRenderFns } from "./UserSettingsPage.vue?vue&type=template&id=1fa00ac1&scoped=true&"
import script from "./UserSettingsPage.vue?vue&type=script&lang=js&"
export * from "./UserSettingsPage.vue?vue&type=script&lang=js&"
import style0 from "./UserSettingsPage.vue?vue&type=style&index=0&id=1fa00ac1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa00ac1",
  null
  
)

export default component.exports